import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Container } from 'semantic-ui-react';
import moment from 'moment';
import AddEntryModalButton from '../AddEntryModalButton/container';
import ConfirmationModal from '../ConfirmationModal/component';
import './index.css';

const defaultSortMethod = (a, b, desc) => {
  const dateA = moment(a, 'MMMM D, YYYY');
  const dateB = moment(b, 'MMMM D, YYYY');

  if (!dateA.isValid()) { return 1; }
  if (!dateB.isValid()) { return -1; }

  if (dateA > dateB) { return -1; }
  if (dateA < dateB) { return 1; }

  return 0;
};

const getFormattedDate = date => (
   moment(date.Date, 'YYYY-MM-DD').isValid()
   ? moment(date.Date, 'YYYY-MM-DD').format('MMMM D, YYYY')
   : ''
);

const getDateColumnOptions = column => ({
  Header: column.title,
  id: column.title,
  accessor: date => getFormattedDate(date),
});

const getTextColumnOptions = column => ({
  Header: column.title,
  accessor: column.title,
});

const getLinkColumnOptions = column => ({
  Header: column.title,
  accessor: column.title,
  Cell: (data) => {
    if (!data || !data.row || !data.row[column.title]) { return ''; }
    let nameAndLink = data.row[column.title].split('|||');
    if (nameAndLink.length <= 1) { nameAndLink = [data.row[column.title], data.row[column.title]]; }
    return <a href={nameAndLink[1]}>{nameAndLink[0]}</a>;
  },
});

const getDeleteColumnOptions = (column, firebase) => ({
  Header: null,
  accessor: column.title,
  maxWidth: 80,
  Cell: row => row && row.value &&
  <ConfirmationModal
    onClick={() => firebase.database().ref(`rows/${row.value}`).remove()}
  />,
});

const getFileColumnOptions = column => ({
  Header: column.title,
  id: column.title,
  accessor: column.title,
  Cell: row => row && row.value && Object.keys(row.value).map((val, i) => (
    <span>
      <a href={row.value[val].url} download={row.value[val].name}>{row.value[val].name}</a>
      {i < row.value.length && <div className="link-seperator" />}
    </span>
  )),
});


class NewSection extends Component {
  createTable(title, columns, rows, tableId) {
    const reactTableColumns = [{
      Header: title,
      columns: columns.map((column) => {
        switch (column.dataType) {
          case 'date':
            return getDateColumnOptions(column);
          case 'file':
            return getFileColumnOptions(column);
          case 'link':
            return getLinkColumnOptions(column);
          case 'id':
            return getDeleteColumnOptions(column, this.props.firebase);
          default:
            return getTextColumnOptions(column);
        }
      }),
    }];

    return (
      <Container fluid className="table-card" key={tableId}>
        <ReactTable
          data={rows}
          columns={reactTableColumns}
          showPagination={false}
          defaultSorted={columns.some(col => col.title === 'Date') ? [{ id: 'Date', desc: true }] : undefined}
          defaultSortMethod={defaultSortMethod}
          sortable={false}
          showPageSizeOptions={false}
          pageSize={500}
          resizable={false}
        />
        <AddEntryModalButton
          tableId={tableId}
          columns={columns}
        />
      </Container>
    );
  }
  render() {
    const { tables, rows } = this.props;
    return (
      <div className="table-holder">
        {tables.map(table => this.createTable(table.title, table.columns, rows[table.id], table.id))}
      </div>
    );
  }
}

export default NewSection;



// WEBPACK FOOTER //
// ./src/modules/NewSection/component.js